import { MovingWorldsBannerLogoLink } from '../../layout/MovingWorldsLogo';
import loginBackground from '../background-images/LoginBackground.png';
import cx from 'classix';
type LogInBackgroundProps = {
  background?: string;
  backgroundRepeat?: string;
  includeLogo?: boolean;
  alignContentCenter?: boolean;
} & React.PropsWithChildren;

export const LogInBackground = (props: LogInBackgroundProps) => {
  const { background, backgroundRepeat, includeLogo = true, alignContentCenter = true } = props;

  const backgroundImage = background || loginBackground;

  //We use a background color _and_ and a background image here because the svgs don't match the aspect ratio needed
  //so we set them to full size and then hide the non-covered parts with a matching background
  return (
    <div className='w-full h-full flex flex-row'>
      <div
        className='hidden h-screen w-1/2 xl:flex justify-start items-start'
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: `${backgroundRepeat ? backgroundRepeat : 'no-repeat'}`,
          backgroundColor: '#F9FAFB',
          backgroundPosition: 'center',
        }}
      >
        {includeLogo && (
          <MovingWorldsBannerLogoLink height='20' className='flex mt-6 ml-6 text-brand-500' />
        )}
      </div>
      <div
        className={cx(
          'w-full xl:w-1/2 md:px-8 md:py-4 flex justify-center overflow-y-auto',
          alignContentCenter && 'items-center',
        )}
      >
        {props.children}
      </div>
    </div>
  );
};
